// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"HomePage_pageWrap__1WkJQ"};